angular.module('bribac.entities.ibacFactory', [])

  .value('ibacFactory', function ibacFactory(data) {
    return angular.merge({
      id: null,
      macAddress: null,
      cycles: null,
      lastCalibrated: null,
      cyclesLeftUntilMaintenance: null,
      daysLeftUntilMaintenance: null,
      lastUsed: null,
      activationEvents: []
    }, data)
  })
